import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import InputNumber from "../../atoms/InputNumber/InputNumber";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Fiveth = ({ formData, setFormData, onValidationChange }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(!!formData.weight && formData.weight !== "0");
  }, [formData.weight, onValidationChange]);

  return (
    <InputNumber
      label={t("animalInfo:QUESTION_FIVE.WEIGHT")}
      value={formData.weight?.toString()}
      onChange={(value) => setFormData({ ...formData, weight: value })}
      endAdornment="kg"
      maxValue={formData.species === "cat" ? "30" : "150"}
    />
  );
};

export default Fiveth;
